export const THEME = {
  LIGHT: "light",
  DARK: "dark"
};
export const FEEDBACK_CONTENT = {
  DETAILS: "details",
  THANKS: "thanks",
  SORRY: "sorry"
};